import Stat from './characterSetting/stat/Stat';
import {isNotDefined, namespace} from './../utils/util';

(function ($) {
  "use strict";

  // import doT.js
  require('../vendor/doT-v1.1.2/doT.min');

  namespace('nc.lineage');

  nc.lineage.statSetting = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.statSetting require options object');

    return new Stat(options).init();
  };
}(jQuery));


// WEBPACK FOOTER //
// ./_src/js/world/stat-setting.js